export default [
  {
    path: "/tendik/laporan-absensi",
    name: "tendik-laporan-absensi",
    component: () => import("../../views/tendik/LaporanAbsensi.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tendik", url: "/submenu/tendik" },
        {
          title: "Laporan Absensi",
          active: true,
        },
      ],
      pageTitle: "Laporan Absensi",
    },
  },
  {
    path: "/tendik/slip-gaji",
    name: "tendik-slip-gaji",
    component: () => import("../../views/tendik/SlipGaji.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tendik", url: "/submenu/tendik" },
        {
          title: "Slip Gaji",
          active: true,
        },
      ],
      pageTitle: "Slip Gaji",
    },
  },
  {
    path: "/tendik/kuisioner",
    name: "tendik-kuisioner",
    component: () => import("../../views/tendik/Kuisioner.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tendik", url: "/submenu/tendik" },
        {
          title: "Kuisioner",
          active: true,
        },
      ],
      pageTitle: "Kuisioner",
    },
  },
  {
    path: "/tendik/kerjasama",
    name: "tendik-kerjasama",
    component: () => import("../../views/tendik/kerjasama/Kerjasama.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Tendik", url: "/submenu/tendik" },
        {
          title: "Kerjasama",
          active: true,
        },
      ],
      pageTitle: "Kerjasama",
    },
  },
  {
    path: "/tendik/kerjasama/moa",
    name: "tendik-kerjasama-moa",
    component: () => import("../../views/tendik/kerjasama/moa/Moa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "MoA", active: true },
      ],
      pageTitle: "Moa",
    },
  },
  {
    path: "/tendik/kerjasama/tambah-moa",
    name: "tendik-kerjasama-tambah-moa",
    component: () => import("../../views/tendik/kerjasama/moa/TambahMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "MoA", url: "/tendik/kerjasama/moa" },
        { title: "Tambah MoA", active: true },
      ],
      pageTitle: "Tambah Moa",
    },
  },
  {
    path: "/tendik/kerjasama/moa/pihak-terkait/:moaId",
    name: "tendik-kerjasama-moa-pihak-terkait",
    component: () =>
      import("../../views/tendik/kerjasama/moa/MoaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "MoA", url: "/tendik/kerjasama/moa" },
        { title: " Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/tendik/kerjasama/moa/:moaId/dokumen",
    name: "tendik-kerjasama-moa-dokumen",
    component: () =>
      import("../../views/tendik/kerjasama/moa/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "MoA", url: "/tendik/kerjasama/moa" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/tendik/kerjasama/ia",
    name: "tendik-kerjasama-ia",
    component: () => import("../../views/tendik/kerjasama/ia/Ia.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "IA", active: true },
      ],
      pageTitle: "IA",
    },
  },
  {
    path: "/tendik/kerjasama/tambah-ia",
    name: "tendik-kerjasama-tambah-ia",
    component: () => import("../../views/tendik/kerjasama/ia/TambahIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "IA", url: "/tendik/kerjasama/ia" },
        { title: "Tambah IA", active: true },
      ],
      pageTitle: "Tambah IA",
    },
  },
  {
    path: "/tendik/kerjasama/ia/bentuk-kegiatan/:iaId",
    name: "tendik-kerjasama-ia-bentuk-kegiatan",
    component: () =>
      import("../../views/tendik/kerjasama/ia/BentukKegiatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "IA", url: "/tendik/kerjasama/ia" },
        { title: "Bentuk Kegiatan", active: true },
      ],
      pageTitle: "Bentuk Kegiatan",
    },
  },

  {
    path: "/tendik/kerjasama/ia/pihak-terkait/:iaId",
    name: "tendik-kerjasama-ia-pihak-terkait",
    component: () =>
      import("../../views/tendik/kerjasama/ia/IaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "IA", url: "/tendik/kerjasama/ia" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/tendik/kerjasama/ia/:iaId/dokumen",
    name: "tendik-kerjasama-ia-dokumen",
    component: () =>
      import("../../views/tendik/kerjasama/ia/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "tendik", url: "/submenu/tendik" },
        { title: "Kerjasama", url: "/tendik/kerjasama" },
        { title: "IA", url: "/tendik/kerjasama/ia" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
];
